import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ArticlePreview from '../articlePreview';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';
import createArticleProps from '../../../utils/recommendations/createArticleProps';
import { createRecommendationClickTracker } from '../../../utils/trackers/trackRecommendations';

const panelName = 'article-preview-recommended-article';

const getIndex = (state, { panel: { launchProps: { index } } }) => index;
const getData = ({ recommendations: { data } }) => data;

export const mapStateToProps = createSelector([getIndex, getData], (index, data) => {
  const recommendationEntry = data.recommendations[index];

  const articleProps = createArticleProps(recommendationEntry, index);

  const {
    contentType, documentType, documentSubtype, pii, doi,
  } = articleProps;
  const eventData = createArticleEvents(
    panelName, { contentType, documentType, documentSubtype }, { pii, doi },
  );

  return {
    ...articleProps,
    eventData,
    onComponentClick: createRecommendationClickTracker(panelName, articleProps),
  };
});

export default connect(mapStateToProps)(ArticlePreview);
